/* 引き出しカートのスクロールが一番下（一番上）で止まる問題の対策（2026-10-02）。
   iPhone（iOS 26など）では、中身を端までスクロールすると、次の指の動きが後ろのページに取られ、
   カートを開いている間はページが動かないため、上に戻せなくなることがある。
   指を置いた瞬間に中身を1pxだけ内側へずらし、いつでも上下どちらにも動ける状態にしておく。 */
(() => {
  if (window.kazuDrawerScrollFix) return;
  window.kazuDrawerScrollFix = true;
  const bind = (drawer) => {
    const body = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]');
    if (!body || body.dataset.kazuScrollFix) return;
    body.dataset.kazuScrollFix = 'true';
    body.addEventListener('touchstart', () => {
      const max = body.scrollHeight - body.clientHeight;
      if (max <= 1) return;
      if (body.scrollTop <= 0) body.scrollTop = 1;
      else if (body.scrollTop >= max - 0.5) body.scrollTop = max - 1;
    }, { passive: true });
  };
  const scan = () => document.querySelectorAll('cart-drawer').forEach(bind);
  scan();
  if (window.customElements) customElements.whenDefined('cart-drawer').then(scan);
  document.addEventListener('dialog:after-show', scan, true);
})();
